import React from 'react';

const ArrowIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 1024 1024"
  >
    <path
      fill="#4a4a4a"
      d="M541.003 753.893l421.831-421.831q34.274-29 0-58.002-29-34.274-58.002 0l-392.832 390.193-392.832-390.193q-29-34.274-58.002 0-34.274 29 0 58.002l421.831 421.831q13.184 13.184 29 13.184t29-13.184z"
    />
  </svg>
);

export default ArrowIcon;
